function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3359 5.38281L9.89062 4.91406C9.77344 4.79688 9.58594 4.79688 9.49219 4.91406L5.85938 8.54688V0.53125C5.85938 0.390625 5.71875 0.25 5.57812 0.25H4.92188C4.75781 0.25 4.64062 0.390625 4.64062 0.53125V8.54688L0.984375 4.91406C0.890625 4.79688 0.703125 4.79688 0.585938 4.91406L0.140625 5.38281C0.0234375 5.47656 0.0234375 5.66406 0.140625 5.78125L5.03906 10.6797C5.15625 10.7969 5.32031 10.7969 5.4375 10.6797L10.3359 5.78125C10.4531 5.66406 10.4531 5.47656 10.3359 5.38281Z",
  fill: "#F92626"
});

var SvgReduceIcon = function SvgReduceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReduceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReduceIcon.be61a057.svg";
export { ForwardRef as ReactComponent };